import Accordion from 'Presentation/Components/Accordion'
import TabsUnderline from 'Presentation/Components/Tabs/Underline'
import { TabsUnderlineProps } from 'Types/Presentation/Components/Tabs/Underline'

//////////////////////////////
// Components of Components //
//////////////////////////////

interface CheckboxListProps {
	lists: {
		key: string
		label: string
	}[]
}

export const CheckboxLists: React.FC<CheckboxListProps> = ({ lists }) => {
	return (
		<div
			className="border-kumopack-grey-200 p-2"
			style={{ borderStyle: 'solid', borderWidth: '1px', borderRadius: '6px' }}>
			{lists.map((list, index) => (
				<div className="mb-2" key={`product-checkbox-list-${list.key}-${index}`}>
					<div className="form-check form-check-custom">
						<input className="form-check-input" type="checkbox" value="" id={list.key} />
						<label className="form-check-label text-kumopack-grey-700" htmlFor={list.key}>
							{list.label}
						</label>
					</div>
				</div>
			))}
		</div>
	)
}

//////////
// Main //
//////////

interface Props extends TabsUnderlineProps {
	title: string | JSX.Element
	boxGroupId: string
	defaultShow?: boolean
}

const CheckboxGroupAccordion: React.FC<Props> = ({
	defaultShow,
	title,
	boxGroupId,
	tabContents,
	tabNames,
}) => {
	return (
		<>
			<Accordion defaultShow={defaultShow} id={boxGroupId} title={title}>
				<TabsUnderline tabNames={tabNames} tabContents={tabContents} />
			</Accordion>
		</>
	)
}

export default CheckboxGroupAccordion
